import * as React from 'react';
import { Headerv2Categories } from '@reverbdotcom/discovery-ui';

export default class HeaderNavLinks extends React.Component {
  constructor() {
    super();
    this.state = {
      activeDropdownKey: null,
    };

    this.onDropdownOpen = this.onDropdownOpen.bind(this);
  }

  onDropdownOpen(key) {
    this.setState({ activeDropdownKey: key });
  }

  render() {
    return (
      <Headerv2Categories
        activeDropdown={this.state.activeDropdownKey}
        onOpen={this.onDropdownOpen}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./javascripts/components/header/header_nav_links.jsx